<template>
	<div class="page page-bg-render" data-name="report_list">
		<div class="page-content infinite-scroll-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					<span>문항/강의 오류신고 목록</span>
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div class="block">
				<div class="row">
					<div class="left"></div>
					<div class="right">
						<button class="button button-fill" v-on:click="addContentsReportClick">새로 신고하기</button>
					</div>
				</div>
			</div>

			<div class="block-title">
				내가 신고한 문항/강의 오류신고 목록
			</div>

			<div class="list media-list">
				<ul>
					<template v-for="(item,i) in reportList">
					<li :key="'i'+i">
						<a href="#" class="item-link item-content" :data-index="i" @click="editContentsReportClick">
							<div class="item-inner">
								<div class="item-title-row">
									<div class="item-title">
										<span>code : {{item.CS_CODE}}</span>
										<span>({{toDate(item.CS_DATETIME)}})</span>
									</div>
									<div class="item-after">
										<span>{{(item.CS_STATUS == 'writed') ? ("접수대기중") : (item.PROC_DATETIME)}}</span>
									</div>
								</div>
								<div class="item-subtitle">
									<template v-for="(option, j) in getErrorTypes(item.CS_OPTIONS)">
										<span :key="'j'+j" style="border:1px solid #ddd; line-height:26px; padding: 0 2px; margin-right:2px;"><b>{{toCSType(option)}}</b></span>
									</template>
								</div>
								<div class="item-text">{{toContent(item.CS_CONTENT)}}</div>
							</div>
						</a>
					</li>
					</template>
				</ul>
			</div>

			<div class="preloader infinite-scroll-preloader" style="display:none"></div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';

	import store from '../../../js/store';

	import MODULE from '../../../js/common/module';
	import AUTH from '../../../js/common/auth.js';
	import PAGES from '../../../js/pages';
	import API from '../../../js/common/api.js';
	import CONST from '../../../js/common/constant';
	
	export default {
		data() {
			return {
				pageNo: 1,
				pageSize: 20,
				reportList: [],

				allowInfinite: true,
				maxPageNo: 0
			}
		},
		mounted() {
			var _this = this;

			$('.infinite-scroll-content').on('infinite', _this.onInfinite);

			$(document).on('page:init page:reinit', '.page[data-name="report_list"]', this.onPageShow);

			setTimeout(function() {
				//
			}, 300);
		},
		methods: {
			onPageShow(e) {
				var _this = this;
				var page = e.detail;

				if (page.direction == "forward") {
					// menu click
					_this.loadReportList(1);	// 1 page (first page)
				} else if (page.direction == "backward") {
					// pop page return
					var returnObj = PAGES.getReturnObj();
					if (returnObj != undefined) {
						if (returnObj.code == "NEED_REFRESH") {
							_this.loadReportList(1);	// 1page (refresh first page)
						}
					}
				}
			},
			onInfinite(){
				const _this = this;

				if(!_this.allowInfinite) return;
				_this.allowInfinite = false;
				
				$('.infinite-scroll-preloader').show();				
				
				setTimeout(function () {
					_this.allowInfinite = true;

					if(_this.pageNo >= _this.maxPageNo){			
						_this.$f7.infiniteScroll.destroy('.infinite-scroll-content');
						$('.infinite-scroll-preloader').remove();
						return;
					}
				
					var newPageNo = _this.pageNo + 1;	
					_this.loadReportList(newPageNo);

				}, 1000);
			},
			getErrorTypes(options) {
				var _this = this;

				if (MODULE.Util.isEmpty(options)) {
					return [];
				}

				return MODULE.Util.splitGroupValue(options);
			},
			loadReportList(pageNo) {
				var _this = this;

				let param = {
					pPageNo: pageNo,
					pPageSize: _this.pageSize
				};

				API.ajaxRequest({
					url: API.getContentsReportListUrl(),
					data: param
				}).then(function (data) {
					_this.pageNo = pageNo;

					if (pageNo == 1) {
						MODULE.Util.clearArray(_this.reportList);
					}

					for (var i=0; i<data.reportList.length; i++) {
						var item = data.reportList[i];
					
						_this.reportList.push(item);
					}
				}).catch(function (code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			addContentsReportClick() {
				var _this = this;

				var url = PAGES.SUB_CONTENTS_REPORT;
				var param = {
					csKey: undefined,
					code: undefined
				}

				PAGES.popPage(url, param);
			},
			editContentsReportClick(e) {
				var _this = this;
				var element = $(e.target).closest("a");
				var index = element.data("index");
				var item = _this.reportList[index];

				var url = PAGES.SUB_CONTENTS_REPORT;
				var param = {
					csKey: item.CS_KEY,
					code: item.CS_CODE
				}

				PAGES.popPage(url, param);
			},
			toDate(datetime) {
				return moment(datetime).format("YYYY-MM-DD HH:mm");
			},
			toCSType(csTypeId) {
				return CONST.csType[csTypeId].name;
			},
			toContent(content) {
				return (MODULE.Util.isEmpty(content) ? "오류 설명 없음." : content);
			}
			
		}
	}

</script>